import { useFormContext } from 'react-hook-form'
import { OptionCard } from '../ui/OptionCard'
import type { FormData } from './FormWizard'

const serviceOptions = [
  {
    value: 'new-install',
    label: 'New Aquarium Installation',
    description: 'Custom design and professional installation',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      </svg>
    ),
  },
  {
    value: 'maintenance',
    label: 'Maintenance & Service',
    description: 'Regular cleaning, water testing, and care',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    value: 'emergency',
    label: 'Emergency Repair',
    description: 'Urgent issues - leaks, equipment failure, sick fish',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    ),
  },
  {
    value: 'consultation',
    label: 'Consultation',
    description: 'Expert advice and planning for your project',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
  },
]

export function StepServiceType() {
  const { register, watch, formState: { errors } } = useFormContext<FormData>()
  const selectedValue = watch('service_type')

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          How can we help you?
        </h2>
        <p className="text-gray-600">
          Select the service that best describes what you need
        </p>
      </div>

      <div className="grid gap-4">
        {serviceOptions.map((option) => (
          <OptionCard
            key={option.value}
            {...register('service_type', { required: 'Please select a service type' })}
            value={option.value}
            label={option.label}
            description={option.description}
            icon={option.icon}
            selected={selectedValue === option.value}
          />
        ))}
      </div>

      {errors.service_type && (
        <p className="text-sm text-red-600 text-center mt-4">
          {errors.service_type.message}
        </p>
      )}
    </div>
  )
}
